var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7852,
    cy: 17,
    r: 16.3108,
    stroke: "#A5A5A5",
    strokeWidth: 1.37838
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7963 6.5846C18.4374 6.22574 17.8556 6.22574 17.4967 6.5846L11.6487 12.4326C11.2899 12.7914 11.2899 13.3733 11.6487 13.7321C12.0076 14.091 12.5894 14.091 12.9483 13.7321L18.1465 8.53392L23.3447 13.7321C23.7035 14.091 24.2854 14.091 24.6442 13.7321C25.0031 13.3733 25.0031 12.7914 24.6442 12.4326L18.7963 6.5846ZM17.2276 26.9911C17.2276 27.4986 17.639 27.91 18.1465 27.91C18.654 27.91 19.0654 27.4986 19.0654 26.9911L17.2276 26.9911ZM17.2276 7.23437L17.2276 26.9911L19.0654 26.9911L19.0654 7.23438L17.2276 7.23437Z",
    fill: "#A5A5A5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16.3108,
    stroke: "#A5A5A5",
    strokeWidth: 1.37838
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0111 6.5846C18.6522 6.22574 18.0704 6.22574 17.7116 6.5846L11.8636 12.4326C11.5047 12.7914 11.5047 13.3733 11.8636 13.7321C12.2225 14.091 12.8043 14.091 13.1631 13.7321L18.3613 8.53392L23.5595 13.7321C23.9184 14.091 24.5002 14.091 24.8591 13.7321C25.2179 13.3733 25.2179 12.7914 24.8591 12.4326L19.0111 6.5846ZM17.4424 26.9911C17.4424 27.4986 17.8538 27.91 18.3613 27.91C18.8688 27.91 19.2802 27.4986 19.2802 26.9911L17.4424 26.9911ZM17.4424 7.23437L17.4424 26.9911L19.2802 26.9911L19.2802 7.23438L17.4424 7.23437Z",
    fill: "#A5A5A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.1fbda13beda4f75f416e313c730ac3cb.svg";
export { ForwardRef as ReactComponent };